import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=b70818f8&"
import script from "./ContactView.vue?vue&type=script&lang=ts&"
export * from "./ContactView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports